import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import ArrowBack from '@components/ArrowBack';
import Loading from '@components/Loading';
import NotFound from '@components/NotFound';
import Profile from '@components/Profile';
import Repositories from '@components/Repositories';

import { useUser } from '@contexts/UserContext';

import { UserRouteParams } from '@models/RouteParams';

import { Container, LoadingContainer } from './styles';

const UserPage = () => {
  const { username } = useParams<UserRouteParams>();
  const { fetchUser, user, loading } = useUser();

  useEffect(() => {
    fetchUser(username);
  }, [fetchUser, username]);

  if (loading) {
    return (
      <LoadingContainer>
        <Loading />
      </LoadingContainer>
    );
  }

  if (!loading && !user) {
    return (
      <NotFound>
        <ArrowBack color="primary" />

        <p>User not found</p>
      </NotFound>
    );
  }

  return (
    <Container>
      <Profile />

      <Repositories />
    </Container>
  );
};

export default UserPage;
